"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number,
    item: Object
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    lookDetails: function lookDetails(e) {
      window.open(e);
    }
  }
};